import React from 'react'
import cl from 'classnames'

import Icons from './Icons'

import styles from './styles.module.scss'

export type IconType = keyof typeof Icons

type IconProps = React.HTMLAttributes<HTMLSpanElement> &
	React.RefAttributes<HTMLSpanElement> & {
		type: IconType
	}

const Icon: React.FC<IconProps> = ({ type, ...props }) => {
	const IconComponent = Icons[type]

	if (!IconComponent) {
		return null
	}

	const style =
		type === 'close'
			? cl(props.className, styles.closeIconWrapper)
			: cl(props.className, styles.iconWrapper)

	return (
		<span {...props} className={style} role="img">
			<IconComponent />
		</span>
	)
}

export default Icon
